module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDY5LjczIDY3NC4wNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNkOGVjZmY7b3BhY2l0eTowLjI7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5sdWNodDwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9Ikx1Y2h0Ij48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0MDY5LjczIiBoZWlnaHQ9IjY3NC4wNiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lucht.svg
// module id = L0yn
// module chunks = 0